

export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.accessToken) {
    return { Authorization: 'Bearer ' + user.accessToken};
  } else {

    //return console.log('logged out');
    window.open(window.location.origin + "/auth/signin-2", 'toolbar=0,location=0,menubar=0');
  }
}